export default __webpack_public_path__ + "static/media/audio.2b86b91e.svg";